import React from "react";
import { Layout } from "antd";

const { Content } = Layout;
export const HistoryContent = (props) => (
  <div className="col-md-12  mt-4">{props.children}</div>
);
